export default __webpack_public_path__ + "static/media/doctors-box3.d461de2a.svg";